import unleash from '@/utils/unleash';

export default {
  data() {
    return {
      unleashUpdated: 0,
    };
  },
  methods: {
    isFlagEnabled(name) {
      return this.unleashUpdated >= 0 && unleash.isEnabled(name);
    },
    getFlagVariant(name) {
      return unleash.getVariant(name);
    },
  },
  created() {
    unleash.on('update', () => {
      // eslint-disable-next-line no-plusplus
      this.unleashUpdated++;
    });
  },
};
